import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import {User, UserState} from "../../store/user/types";
import {connect} from "react-redux";
import {AppState} from "../../store";
import {thunkUserSave} from "../../store/thunks";

interface IProps{
    t: any;
    thunkUserSave: any;
    user: UserState;
    open: boolean;
    closeDialog : any;    
}

interface IHeaderState {
    user : User;
    canSave? : boolean;
    open: boolean;
    errorMsg: string;
}

class ChangePasswordDialog extends React.Component<IProps,IHeaderState>{

    state = {
        user: this.props.user.user ? this.props.user.user : {login:''},
        open : this.props.open,
        canSave: undefined,
        errorMsg: ''
    }

    handleClose = () => {
        this.setState({ errorMsg: ''});
        this.setState({ open: false });
        this.props.closeDialog();
    };

    handleChange = (event : React.ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        this.setState(prevState => ({
            user: {
                ...prevState.user,
                password: value
            }
        }));
        let pwd1 = (document.getElementById('password') as HTMLInputElement).value;
        let pwd2 = (document.getElementById('password2') as HTMLInputElement).value;
        this.setState({ canSave: (pwd1 === pwd2) && pwd1.length >5});
        this.setState({ errorMsg:(pwd1 === pwd2) ? pwd1.length >5 ? '' : this.props.t('ChangePasswordDialog.pwdLength') : this.props.t('ChangePasswordDialog.noMatch')});
    };

    handleSave = () =>{
        this.props.thunkUserSave(this.state.user);
        this.setState({ errorMsg: ''});
    }

    render(){
        return(
            <Dialog open={this.state.open}>
                <DialogTitle id="form-dialog-title">{this.props.t('ChangePasswordDialog.title')}</DialogTitle>
                <DialogContent>
                    <p>{this.state.errorMsg}</p>
                    <form>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="user">{this.props.t('ChangePasswordDialog.password')}</InputLabel>
                                <Input id="password" name="password" type="password" autoFocus onChange={this.handleChange}/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                <InputLabel htmlFor="password">{this.props.t('ChangePasswordDialog.password2')}</InputLabel>
                                <Input id="password2" name="password2" type="password" onChange={this.handleChange}/>
                            </FormControl>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        {this.props.t('ChangePasswordDialog.cancel')}
                    </Button>
                    <Button onClick={this.handleSave} color="primary" disabled={!this.state.canSave}>
                        {this.props.t('ChangePasswordDialog.save')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    shouldComponentUpdate(nextProps: any, nextState : any){
        if(nextProps.open != this.state.open){
            nextState.open = nextProps.open;
        }
        return true;
    }

}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {thunkUserSave})(ChangePasswordDialog);